import cheninBlancImg from "../../../images/wineBottles/CheninBlanc.png";
import cheninCrianzaImg from "../../../images/wineBottles/CheninCrianza.png";
import conchaLolaCheninImg from "../../../images/wineBottles/ConchaChenin.png";
import conchaLolaEspumosoRoseImg from "../../../images/wineBottles/ConchaEspumoso.png";
import granCanarioImg from "../../../images/wineBottles/GranCanario.png";
import inizioImg from "../../../images/wineBottles/Inizio.png";
import sierraInyaaImg from "../../../images/wineBottles/Inyaa.png";
import merlotImg from "../../../images/wineBottles/Merlot.png";
import rose9Img from "../../../images/wineBottles/Rose9.png";
import sierraMonarcaImg from "../../../images/wineBottles/SierraMonarca.png";
import sierraNegraImg from "../../../images/wineBottles/SierraNegra.png";
import sierraRealImg from "../../../images/wineBottles/SierraReal.png";

const AMAZON_STORE_URL =
  "https://www.amazon.com.mx/s?me=A1TPZV9LIMUF1L&marketplaceID=A1AM78C64UM0Y8";

export const wines = [
  {
    id: "gran-canario",
    name: "Gran Canario",
    type: "White Wine",
    price: "",
    cont: "750",
    stock: "6",
    alcoholVol: "13",
    descriptionEN:
      "Gran Canario is a distinctive expression of Palomino from Valle de Guadalupe, a white wine with its own personality and a profile made for those who enjoy trying something different. With barrel aging, it gains depth and a refined presence that stands out for its originality and character.",
    descriptionES:
      "Gran Canario es una expresión distinta de Palomino del Valle de Guadalupe, un blanco con personalidad propia y un perfil que invita a probar algo diferente. Con su paso por barrica, ofrece mayor profundidad y una presencia elegante que se disfruta por su originalidad y carácter.",
    temp: "8-10",
    noseEN: "Honey, syrup and dried nuts.",
    noseES: "Miel, almíbar y frutos secos.",
    colorEN: "Bright golden color with copper highlights.",
    colorES: "Color dorado brillante con destellos cobrizos.",
    mouthEN: "Semi-dry with good acidity.",
    mouthES: "Semiseco con buena acidez.",
    pairingEN: "Seafood, creamy cheeses and dishes with buttery sauces.",
    pairingES: "Mariscos, quesos cremosos y platillos con salsas untuosas.",
    image: granCanarioImg,
    amazonUrl:
      "https://www.amazon.com.mx/Blanco-Sierra-Vita-Canario-Palomino/dp/B0D92QD8Z2",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-blanco-sierra-vita-gran-canario-palomino-750-ml/p/MLM38200570",
  },
  {
    id: "sierra-monarca",
    name: "Sierra Monarca",
    type: "Red Blend",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13",
    descriptionEN:
      "Sierra Monarca is our pride: winner of the Grand Gold Medal and Mexico Revelation Wine 2025 at Concours Mondial de Bruxelles. Crafted in Valle de Guadalupe from Merlot, Malbec, Cabernet Sauvignon, and Cabernet Franc, it is an elegant, layered wine made to be enjoyed on its own.",
    descriptionES:
      "Sierra Monarca es nuestro orgullo: ganador de la Gran Medalla de Oro y Vino Revelación de México 2025 en el Concours Mondial de Bruxelles. Elaborado en Valle de Guadalupe con Merlot, Malbec, Cabernet Sauvignon y Cabernet Franc, es un vino elegante y profundo hecho para disfrutarse por sí solo.",
    temp: "18",
    noseEN:
      "Cherry, raspberry, blackberry, currant, black plum, black pepper, vanilla, cinnamon and licorice.",
    noseES:
      "Cereza, frambuesa, mora, grosella, ciruela negra, pimienta negra, vainilla, canela y regaliz.",
    colorEN: "Deep ruby red with terracotta tones.",
    colorES: "Rojo rubí profundo con tonalidades terracota.",
    mouthEN:
      "Dry, medium to full body, balanced acidity, soft tannins, complex and elegant.",
    mouthES:
      "Seco, de cuerpo medio a completo, acidez equilibrada, taninos suaves, complejo y elegante.",
    pairingEN: "Lamb, beef ribs, premium cuts, red meats and aged cheeses.",
    pairingES:
      "Borrego, costillas de res, cortes finos, carnes rojas y quesos maduros.",
    image: sierraMonarcaImg,
    amazonUrl:
      "https://www.amazon.com.mx/Sierra-Vita-Monarca-Vino-Tinto/dp/B0DPJ89R35",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-mezcla-bordelesa-sierra-monarca-sierra-vita-750ml/up/MLMU3131666718",
  },
  {
    id: "concha-lola-rose",
    name: "Concha & Lola Rosé Espumoso",
    type: "Sparkling Rosé",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13",
    descriptionEN:
      "Concha & Lola Sparkling Rosé is a tribute to the joy of sharing, crafted in Valle de Guadalupe from Grenache, Cabernet Sauvignon, Nebbiolo, and French Colombard. Its fresh, vibrant, celebratory style makes it ideal for toasting and enjoying well chilled.",
    descriptionES:
      "Concha & Lola Rosé Espumoso es un homenaje a la alegría de compartir, elaborado en Valle de Guadalupe con Grenache, Cabernet Sauvignon, Nebbiolo y French Colombard. Su estilo fresco, vibrante y festivo lo convierte en una opción ideal para brindar y disfrutar bien frío.",
    temp: "6-8",
    noseEN: "Red berries, strawberry, mandarin, citrus and caramel.",
    noseES: "Frutos rojos, fresa, mandarina, cítricos y caramelo.",
    colorEN: "Bright salmon pink with fine bubbles.",
    colorES: "Rosa salmón brillante con burbuja fina.",
    mouthEN: "Marked creaminess; red fruit flavors and a citrus finish.",
    mouthES: "Untuosidad marcada; sabores de frutos rojos y final cítrico.",
    pairingEN: "Mexican dishes or enjoyed on its own, very cold.",
    pairingES: "Platillos mexicanos o para disfrutarse solo, bien frío.",
    image: conchaLolaEspumosoRoseImg,
    amazonUrl:
      "https://www.amazon.com.mx/Sierra-Vita-Casa-Vinicola-Guadalupe/dp/B0FFY19QQD",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl: "",
  },
  {
    id: "concha-lola-chenin",
    name: "Concha & Lola Chenin Blanc",
    type: "White Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN:
      "Concha & Lola Chenin Blanc with Palomino is a fresh, approachable white wine made to be easy to enjoy. Its light, elegant profile makes it perfect for relaxed moments, with a clean and inviting expression that keeps you coming back for another glass.",
    descriptionES:
      "Concha & Lola Chenin Blanc con Palomino es un blanco fresco, amable y fácil de disfrutar. Su perfil ligero y elegante lo hace perfecto para momentos relajados, con una expresión limpia y accesible que invita a otra copa.",
    temp: "8-10",
    noseEN: "Citrus, orchard fruit and soft floral notes.",
    noseES: "Cítricos, fruta de huerto y notas florales suaves.",
    colorEN: "Pale straw yellow color with bright highlights.",
    colorES: "Color amarillo paja pálido con destellos brillantes.",
    mouthEN: "Fresh entry, light body and crisp finish.",
    mouthES: "Entrada fresca, cuerpo ligero y final limpio.",
    pairingEN:
      "Fresh seafood, grilled fish, citrus salads and soft goat cheeses.",
    pairingES:
      "Mariscos frescos, pescados a la parrilla, ensaladas con cítricos y quesos suaves de cabra.",
    image: conchaLolaCheninImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-blanco-chenin-blancpalomino-conchalola-sierra-vita/up/MLMU3168327731",
  },
  {
    id: "chenin-blanc-crianza",
    name: "Chenin Blanc Crianza",
    type: "White Wine",
    price: "909",
    cont: "750",
    stock: "4",
    alcoholVol: "13",
    descriptionEN:
      "Chenin Blanc Crianza takes the natural freshness of the variety into a broader, more refined expression. With oak barrel aging, it offers added texture and depth, ideal for those looking for a white wine with more presence.",
    descriptionES:
      "Chenin Blanc Crianza lleva la frescura natural de la variedad a una expresión más amplia y refinada. Con paso por barrica, ofrece mayor textura y profundidad, ideal para quien busca un blanco con más presencia.",
    temp: "10",
    noseEN: "Citrus, green apple, honey and vanilla.",
    noseES: "Cítricos, manzana verde, miel y vainilla.",
    colorEN: "Golden yellow color with warm reflections.",
    colorES: "Color amarillo dorado con reflejos cálidos.",
    mouthEN: "Round texture with balanced acidity and a lightly creamy finish.",
    mouthES:
      "Textura redonda con acidez equilibrada y final ligeramente cremoso.",
    pairingEN: "Seafood, chicken and cheeses with acidic notes.",
    pairingES: "Comida del mar, pollo y quesos con notas ácidas.",
    image: cheninCrianzaImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-blanco-sierra-vita-chenin-blanc-crianza-750-ml/up/MLMU484371612",
  },
  {
    id: "chenin-blanc",
    name: "Chenin Blanc",
    type: "White Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN:
      "Chenin Blanc shows a fresh, clean, balanced style that highlights the most approachable side of Valle de Guadalupe whites. It is a wine made for easy enjoyment, with a light and refreshing feel.",
    descriptionES:
      "Chenin Blanc expresa un estilo fresco, limpio y equilibrado que resalta el lado más amable de los blancos del Valle de Guadalupe. Es un vino pensado para disfrutarse con facilidad, con una sensación ligera y refrescante.",
    temp: "8-10",
    noseEN: "Fresh citrus, white fruit and soft floral notes.",
    noseES: "Cítricos frescos, fruta blanca y notas florales suaves.",
    colorEN: "Pale yellow color with greenish highlights.",
    colorES: "Color amarillo pálido con reflejos verdosos.",
    mouthEN: "Light body, bright acidity and refreshing finish.",
    mouthES: "Cuerpo ligero, acidez viva y final refrescante.",
    pairingEN: "Seafood, salads, light pasta dishes and fresh cheeses.",
    pairingES: "Mariscos, ensaladas, pastas ligeras y quesos frescos.",
    image: cheninBlancImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-blanco-sierra-vita-chenin-blanc-750-ml/p/MLM29265598",
  },
  {
    id: "inizio",
    name: "Inizio",
    type: "Red Blend",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13.7",
    descriptionEN:
      "Inizio is a red blend of Shiraz/Syrah, Cabernet Sauvignon, Merlot, and Tempranillo from Valle de Guadalupe, with an expressive and balanced profile. It is a fruit-forward wine with solid structure, made to accompany special moments with a warm, generous presence.",
    descriptionES:
      "Inizio es un ensamble tinto de Shiraz/Syrah, Cabernet Sauvignon, Merlot y Tempranillo del Valle de Guadalupe, con un perfil expresivo y equilibrado. Es un vino de carácter frutal y buena estructura, pensado para acompañar momentos especiales con una presencia cálida y envolvente.",
    temp: "16-18",
    noseEN: "Wild berries, vanilla and a light cocoa note.",
    noseES: "Frutos silvestres, vainilla y una ligera nota de cacao.",
    colorEN: "Intense red color with violet hues.",
    colorES: "Color rojo intenso con matices violáceos.",
    mouthEN:
      "Cherry, plum and dill flavors with good persistence and balanced acidity.",
    mouthES:
      "Sabores a cereza, ciruela y eneldo, con buena permanencia y acidez equilibrada.",
    pairingEN: "Roasted meats, pasta with red sauce and aged cheeses.",
    pairingES: "Carnes asadas, pastas con salsa roja y quesos maduros.",
    image: inizioImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-mezcla-inizio-sierra-vita-valle-de-guadalupe/p/MLM50414228",
  },
  {
    id: "sierra-inyaa",
    name: "Sierra Inyaa",
    type: "Red Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13",
    descriptionEN:
      "Sierra Inyaa is a 100% Shiraz from Valle de Guadalupe and winner of the Gold Medal at Concours Mondial de Bruxelles 2025. Deep, elegant, and expressive, it is a wine with presence, structure, and a memorable character.",
    descriptionES:
      "Sierra Inyaa es un Shiraz 100% del Valle de Guadalupe y ganador de la Medalla de Oro en el Concours Mondial de Bruxelles 2025. Profundo, elegante y expresivo, es un vino con presencia, estructura y un carácter que deja huella.",
    temp: "16-18",
    noseEN: "Dark fruit, black pepper and soft spice notes typical of Syrah.",
    noseES:
      "Fruta negra, pimienta negra y notas especiadas suaves típicas del Syrah.",
    colorEN: "Deep ruby color with violet reflections.",
    colorES: "Color rojo rubí profundo con reflejos violáceos.",
    mouthEN: "Juicy texture, medium body and a spicy finish.",
    mouthES: "Textura jugosa, cuerpo medio y final especiado.",
    pairingEN: "Beef, lamb, poultry and game.",
    pairingES: "Res, cordero, aves y carne de caza.",
    image: sierraInyaaImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-mexicano-sierra-inyaa-sierra-vita-valle-de-gpe/up/MLMU3129076139",
  },
  {
    id: "sierra-negra",
    name: "Sierra Negra",
    type: "Red Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN:
      "Sierra Negra is a Malbec from Valle de Guadalupe, an intense and silky expression of Baja California’s terroir. Its generous, versatile profile makes it a red with presence, ideal for slow enjoyment and for appreciating its more enveloping side.",
    descriptionES:
      "Sierra Negra es un Malbec del Valle de Guadalupe, una expresión intensa y sedosa del terruño de Baja California. Su perfil generoso y versátil lo convierte en un tinto con presencia, ideal para disfrutarse con calma y apreciar su lado más envolvente.",
    temp: "16-18",
    noseEN: "Black fruit.",
    noseES: "Frutos negros.",
    colorEN: "Ruby red with violet tones.",
    colorES: "Rojo rubí con matices violáceos.",
    mouthEN: "Soft texture, ripe fruit expression and medium body.",
    mouthES: "Textura suave, expresión de fruta madura y cuerpo medio.",
    pairingEN: "Grilled meats, burgers and medium-aged cheeses.",
    pairingES: "Carnes a la parrilla, hamburguesas y quesos semimadurados.",
    image: sierraNegraImg,
    amazonUrl:
      "https://www.amazon.com.mx/Sierra-Vita-Casa-Vinicola-Guadalupe/dp/B0DPJ98PCX",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-sierra-vita-sierra-negra-malbec-750-ml/p/MLM29272006",
  },
  {
    id: "sierra-real",
    name: "Sierra Real",
    type: "Red Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13",
    descriptionEN:
      "Sierra Real is a Cabernet Franc-led red from Valle de Guadalupe and winner of the Silver Medal at Concours Mondial de Bruxelles. Elegant and well defined, it is a wine with fine structure, balance, and a more refined expression.",
    descriptionES:
      "Sierra Real es un tinto liderado por Cabernet Franc del Valle de Guadalupe y ganador de la Medalla de Plata en el Concours Mondial de Bruxelles. Elegante y bien definido, es un vino de estructura fina, equilibrio y una expresión más refinada.",
    temp: "16-18",
    noseEN: "Herbal notes, red fruit and light spice typical of Cabernet Franc.",
    noseES:
      "Notas herbales, fruta roja y especias ligeras típicas del Cabernet Franc.",
    colorEN: "Medium to deep ruby red color.",
    colorES: "Color rojo rubí de intensidad media a profunda.",
    mouthEN: "Balanced acidity with fine tannins and a fresh, refined finish.",
    mouthES:
      "Acidez equilibrada con taninos finos y un final fresco y refinado.",
    pairingEN: "Roasted meats, grilled vegetables and semi-aged cheeses.",
    pairingES: "Carnes asadas, vegetales a la parrilla y quesos semimadurados.",
    image: sierraRealImg,
    amazonUrl:
      "https://www.amazon.com.mx/Tinto-Sierra-Vita-Cabernet-Franc/dp/B0D92RB9FQ",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-mexicano-sierra-real-sierra-vita-750ml/up/MLMU3134492090",
  },
  {
    id: "merlot",
    name: "Merlot",
    type: "Red Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN:
      "Sierra Vita Merlot is a 100% Merlot from Valle de Guadalupe and winner of the Gold Medal at Concours Mondial de Bruxelles 2025. It shows the softer, silkier side of the variety, with ripe fruit, smoothness, and a generous feel in the glass.",
    descriptionES:
      "Sierra Vita Merlot es un Merlot 100% del Valle de Guadalupe y ganador de la Medalla de Oro en el Concours Mondial de Bruxelles 2025. Muestra el lado más amable y sedoso de la variedad, con fruta madura, suavidad y una sensación envolvente en copa.",
    temp: "16-18",
    noseEN: "Ripe red fruit, plum and soft spice.",
    noseES: "Fruta roja madura, ciruela y especias suaves.",
    colorEN: "Ruby red color.",
    colorES: "Color rojo rubí.",
    mouthEN: "Smooth body, ripe fruit and gentle tannins.",
    mouthES: "Cuerpo suave, fruta madura y taninos amables.",
    pairingEN: "Pasta, roasted chicken and semi-aged cheeses.",
    pairingES: "Pastas, pollo rostizado y quesos semimadurados.",
    image: merlotImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl: "",
  },
  {
    id: "rose-9",
    name: "Rosé 9",
    type: "Rosé",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN:
      "Rosé 9 is a rosé made from Tempranillo and Mission in Baja California, fresh, bright, and meant to be enjoyed without complication. Its light, cheerful style makes it perfect for relaxed moments, with a lively expression that invites another pour.",
    descriptionES:
      "Rosé 9 es un rosado de Tempranillo y Mission de Baja California, fresco, brillante y hecho para disfrutarse sin complicaciones. Su estilo ligero y alegre lo vuelve perfecto para momentos relajados, con una expresión viva que invita a servir otra copa.",
    temp: "8-10",
    noseEN: "Fresh berries, floral notes and citrus hints.",
    noseES: "Frutos rojos frescos, notas florales y toques cítricos.",
    colorEN: "Soft pink color.",
    colorES: "Color rosa suave.",
    mouthEN: "Refreshing acidity and light body.",
    mouthES: "Acidez refrescante y cuerpo ligero.",
    pairingEN: "Salads, seafood and light appetizers.",
    pairingES: "Ensaladas, mariscos y aperitivos ligeros.",
    image: rose9Img,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl: "",
  },
];